import { useWebAuth } from '../contexts/WebAuthContext';

/**
 * AuditGuard プロパティ
 */
export interface AuditGuardProps {
  /** 子要素 */
  children: React.ReactNode;
}

/**
 * 監査権限ガードコンポーネント
 *
 * auditグループに所属していないユーザーにはアクセス拒否画面を表示する
 * 注意: AdminGuardの内側で使用することを前提としている（認証・admin権限は既にチェック済み）
 */
export function AuditGuard({ children }: AuditGuardProps) {
  const { user } = useWebAuth();

  // auditグループに所属しているか確認
  const hasAuditGroup = user?.groups?.includes('audit') ?? false;

  if (!hasAuditGroup) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-background">
        <div className="text-center max-w-md">
          <div className="text-6xl mb-4">🔍</div>
          <h1 className="text-2xl font-bold text-foreground mb-2">監査権限が必要です</h1>
          <p className="text-muted-foreground mb-6">
            このページは監査権限が必要です。
            <br />
            タスク履歴へのアクセス権限が必要な場合はシステム管理者にお問い合わせください。
          </p>
          <a
            href="/admin"
            className="inline-block px-6 py-3 bg-accent text-foreground rounded-lg hover:bg-accent/80 transition-colors"
          >
            管理画面トップへ
          </a>
        </div>
      </div>
    );
  }

  // auditグループ所属、子要素を表示
  return <>{children}</>;
}
